import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Box from "@mui/system/Box";
import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import CardActions from "@mui/material/CardActions";
import { Grid } from "@mui/material";

const style = {
  position: "absolute",
  top: "30%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  p: 4,
  padding: "0px",
};

const ConfirmModalComponent = (props) => {
  const {
    open,
    onClose,
    cbConfirm,
    title,
    subheader,
    confirmText,
    cancelText,
  } = props;
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Card>
          <CardHeader title={title} sx={{ paddingBottom: 0 }} />
          <CardContent
            sx={{
              fontFamily: "Roboto,Helvetica,Arial,sans-serif",
              fontSize: "1rem",
              color: "rgba(0, 0, 0, 0.6)",
            }}
          >
            {subheader}
          </CardContent>
          <CardActions>
            <Grid container justifyContent="space-between">
              <Grid item>
                <Button type="button" variant="contained" onClick={cbConfirm}>
                  {confirmText ?? "Confirm"}
                </Button>
              </Grid>
              <Grid item>
                <Button type="button" variant="outlined" onClick={onClose}>
                  {cancelText ?? "Cancel"}
                </Button>
              </Grid>
            </Grid>
          </CardActions>
        </Card>
      </Box>
    </Modal>
  );
};

export default ConfirmModalComponent;
